import { t } from "@lingui/macro";
import { WhatsAppTemplateCatalog } from "@repo/ui";
export function CompanyWhatsAppTemplates({
	companyId,
	canManage,
}: {
	companyId: string;
	canManage: boolean;
}) {
	return (
		<WhatsAppTemplateCatalog
			companyId={companyId}
			canManage={canManage}
			labels={{
				source: t({ id: "whatsappTemplates.source", message: "Source" }),
				account: t({
					id: "whatsappTemplates.account",
					message: "Existing account",
				}),
				allSources: t({
					id: "whatsappTemplates.allSources",
					message: "All sources",
				}),
				status: t({ id: "whatsappTemplates.status", message: "Status" }),
				allStatuses: t({
					id: "whatsappTemplates.allStatuses",
					message: "All statuses",
				}),
				allLanguages: t({
					id: "whatsappTemplates.allLanguages",
					message: "All languages",
				}),
				clearFilters: t({
					id: "whatsappTemplates.clearFilters",
					message: "Clear filters",
				}),
				noMatches: t({
					id: "whatsappTemplates.noMatches",
					message: "No templates match these filters.",
				}),
				results: t({ id: "whatsappTemplates.results", message: "Results" }),
				accountHelp: t({
					id: "whatsappTemplates.accountHelp",
					message:
						"Existing account templates are managed in Meta and are view-only here.",
				}),
				accountLoading: t({
					id: "whatsappTemplates.accountLoading",
					message: "Loading existing account templates…",
				}),
				accountLoadError: t({
					id: "whatsappTemplates.accountLoadError",
					message:
						"Existing account templates could not be loaded. Refresh to try again.",
				}),
				authentication: t({
					id: "whatsappTemplates.authentication",
					message: "Authentication",
				}),
				responsesActive: t({
					id: "whatsappTemplates.responsesActive",
					message: "External reply relay active for selected test numbers.",
				}),
				responseLease: t({
					id: "whatsappTemplates.responseLease",
					message: "Reply handoff expires",
				}),
				anotherTest: t({
					id: "whatsappTemplates.anotherTest",
					message: "Prepare another test message",
				}),
				borrowed: t({
					id: "whatsappTemplates.borrowed",
					message: "Borrowed WhatsApp account",
				}),
				borrowHelp: t({
					id: "whatsappTemplates.borrowHelp",
					message:
						"This connection uses externally supplied credentials. Connection changes and automatic replies are disabled.",
				}),
				expiry: t({ id: "whatsappTemplates.expiry", message: "Expires" }),
				sendTest: t({
					id: "whatsappTemplates.sendTest",
					message: "Send one template message",
				}),
				recipient: t({
					id: "whatsappTemplates.recipient",
					message: "Allowed test recipient",
				}),
				variables: t({
					id: "whatsappTemplates.variables",
					message: "Variables, one per line",
				}),
				send: t({ id: "whatsappTemplates.send", message: "Send test message" }),
				sending: t({
					id: "whatsappTemplates.sending",
					message: "Sending\u2026",
				}),
				sent: t({
					id: "whatsappTemplates.sent",
					message: "Meta accepted the message.",
				}),
				sendFailed: t({
					id: "whatsappTemplates.sendFailed",
					message: "The message was not sent.",
				}),
				sendUnknown: t({
					id: "whatsappTemplates.sendUnknown",
					message:
						"Send outcome is unknown. This request will not be resent automatically.",
				}),
				selectTemplate: t({
					id: "whatsappTemplates.selectTemplate",
					message: "Approved template",
				}),

				title: t({
					id: "whatsappTemplates.title",
					message: "WhatsApp templates",
				}),
				global: t({ id: "whatsappTemplates.global", message: "Global" }),
				company: t({ id: "whatsappTemplates.company", message: "Company" }),
				search: t({
					id: "whatsappTemplates.search",
					message: "Search templates",
				}),
				create: t({ id: "whatsappTemplates.create", message: "New template" }),
				refresh: t({
					id: "whatsappTemplates.refresh",
					message: "Refresh status",
				}),
				retry: t({
					id: "whatsappTemplates.retry",
					message: "Register missing / Retry",
				}),
				save: t({ id: "whatsappTemplates.save", message: "Save and submit" }),
				cancel: t({ id: "whatsappTemplates.cancel", message: "Cancel" }),
				edit: t({ id: "whatsappTemplates.edit", message: "Edit" }),
				archive: t({ id: "whatsappTemplates.archive", message: "Archive" }),
				archiveConfirm: t({
					id: "whatsappTemplates.archiveConfirm",
					message:
						"Archive this template? Existing Meta registrations will be retained.",
				}),
				enable: t({
					id: "whatsappTemplates.enable",
					message: "Enable for this company",
				}),
				automatic: t({
					id: "whatsappTemplates.automatic",
					message: "Register automatically",
				}),
				automaticHelp: t({
					id: "whatsappTemplates.automaticHelp",
					message:
						"Register this template for every connected company and on future connections.",
				}),
				registeredAutomatically: t({
					id: "whatsappTemplates.registeredAutomatically",
					message: "Registered automatically",
				}),
				name: t({ id: "whatsappTemplates.name", message: "Title" }),
				language: t({
					id: "whatsappTemplates.language",
					message: "Language code",
				}),
				category: t({ id: "whatsappTemplates.category", message: "Category" }),
				utility: t({ id: "whatsappTemplates.utility", message: "Utility" }),
				marketing: t({
					id: "whatsappTemplates.marketing",
					message: "Marketing",
				}),
				body: t({ id: "whatsappTemplates.body", message: "Message body" }),
				samples: t({
					id: "whatsappTemplates.samples",
					message: "Variable examples, one per line",
				}),
				preview: t({ id: "whatsappTemplates.preview", message: "Preview" }),
				empty: t({
					id: "whatsappTemplates.empty",
					message: "No templates to display.",
				}),
				disconnected: t({
					id: "whatsappTemplates.disconnected",
					message:
						"Connect WhatsApp to register templates. You can prepare templates now.",
				}),
				loading: t({
					id: "whatsappTemplates.loading",
					message: "Loading\u2026",
				}),
				notEnabled: t({
					id: "whatsappTemplates.notEnabled",
					message: "Not enabled",
				}),
				queued: t({
					id: "whatsappTemplates.queued",
					message: "Waiting for registration",
				}),
				previous: t({
					id: "whatsappTemplates.previous",
					message: "Previous version remains approved.",
				}),
				revision: t({ id: "whatsappTemplates.revision", message: "Revision" }),
				checked: t({
					id: "whatsappTemplates.checked",
					message: "Last checked",
				}),
				error: t({
					id: "whatsappTemplates.error",
					message: "Unable to complete the request. Try again.",
				}),
				approved: t({ id: "whatsappTemplates.approved", message: "Approved" }),
				pending: t({
					id: "whatsappTemplates.pending",
					message: "Under review",
				}),
				rejected: t({ id: "whatsappTemplates.rejected", message: "Rejected" }),
				failed: t({
					id: "whatsappTemplates.failed",
					message: "Registration failed",
				}),
				submitting: t({
					id: "whatsappTemplates.submitting",
					message: "Submitting",
				}),
				canceled: t({ id: "whatsappTemplates.canceled", message: "Canceled" }),
				paused: t({ id: "whatsappTemplates.paused", message: "Paused" }),
				disabled: t({ id: "whatsappTemplates.disabled", message: "Disabled" }),
				readOnly: t({ id: "whatsappTemplates.readOnly", message: "View only" }),
				close: t({ id: "whatsappTemplates.close", message: "Close" }),
				saved: t({
					id: "whatsappTemplates.saved",
					message:
						"Saved. Applicable registrations will run in the background.",
				}),
				unknown: t({
					id: "whatsappTemplates.unknown",
					message: "Status unavailable",
				}),
				languageHelp: t({
					id: "whatsappTemplates.languageHelp",
					message: "Use a Meta language code, for example en_US or he.",
				}),
				policyHelp: t({
					id: "whatsappTemplates.policyHelp",
					message: "Global templates are managed by system administrators.",
				}),
				archived: t({ id: "whatsappTemplates.archived", message: "Archived" }),
			}}
		/>
	);
}
